var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var SurveyEntryMyGiHistory = require('./surveyEntryMyGiHistory.jsx');
var Callout = require('../../../components/callout.jsx');

var DashboardWithDataMyGiHistory = createReactClass({
    mixins: [PureRenderMixin],

    getHpiReport: function(){
        var hpiReport = '';

        if(this.props.latestHpi && this.props.latestHpi.paragraphs) {
            hpiReport = this.props.latestHpi.paragraphs.map(function(paragraph){
                return paragraph.text + (paragraph.sectionEnd ? '\n\n' : ' ');
            }).join('');
        }

        return hpiReport;
    },

    downloadPdf: function(e){
        var doc = new window.jsPDF();

        doc.setFontSize(24);
        var title = 'Gi History Report';
        var xOffset = doc.internal.pageSize.width / 2;
        doc.text(title, xOffset, 24, 'center');

        doc.setFontSize(16);
        var splitText = doc.splitTextToSize(this.getHpiReport(), 180);
        doc.text(splitText, 15, 40);
        doc.save('Gi History Report.pdf');

        this.props.clickTracking('Click', e.currentTarget.innerText);
    },

    showSpecialistModal: function(){
        this.props.showModal('MODAL_TYPE_SPECIALIST');
    },

    showBeforeSendHpiModal: function(){
        this.props.clearSendHpiStatus();
        this.props.showModal('MODAL_TYPE_BEFORE_SEND_HPI');
    },

    render: function(){
        var isPracticeIntegrated = Object.keys(this.props.mySpecialistPractice).length > 0 && this.props.mySpecialistPractice.isConnected;

        return (
            <div className="dashboard-with-data">
                <div className="content-header-wrapper">
                    <div className="content-header-small content-header row">
                        <div className="medium-6 column">
                            <h1>Doctor Visit Prep</h1>
                        </div>
                        <div className="medium-6 column">
                            <p className="ops">
                                <SurveyEntryMyGiHistory labelText="ReTake Survey" iconClassName="ion-ios-loop" clickTracking={this.props.clickTracking} />
                                <button className="button" onClick={this.downloadPdf}>Download PDF</button>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row column">
                    <div className="to-my-doctor">
                        {Object.keys(this.props.mySpecialist).length > 0 ? (
                            <div>
                                <p className="doctor-title">{this.props.mySpecialist.displayName}</p>
                                {isPracticeIntegrated && (
                                    <p>
                                        <button className="button success" type="button" onClick={this.showBeforeSendHpiModal}>Send to Doctor</button>
                                    </p>
                                )}
                            </div>
                        ) : (
                            <div>
                                <p>Search for specialists in your area</p>
                                <p>
                                    <button className="button success" type="button" onClick={this.showSpecialistModal}>Find a Specialist</button>
                                </p>
                            </div>
                        )}
                    </div>

                    {this.props.isHpiSent && (
                        <div className="send-report-success">
                            <Callout type="success" message="Congratulations, you sent your report to your doctor" handleClose={this.props.clearSendHpiStatus} />
                        </div>
                    )}

                    <div className="hpi-report">
                        <h1>Gi History Report</h1>
                        {this.getHpiReport()}
                    </div>
                </div>
            </div>
        )
    }
});

module.exports = DashboardWithDataMyGiHistory;



// WEBPACK FOOTER //
// ./src/common/routes/dashboard/components/layout/dashboardWithDataMyGiHistory.jsx